(function(){
  function init(){
    const nav = document.querySelector('[data-isw-rewards-nav]');
    const dialog = document.getElementById('isw-rewardDialog');

    function showDialog(title, body){
      if(!dialog) return;
      const t=dialog.querySelector('[data-dialog-title]');
      const b=dialog.querySelector('[data-dialog-text]');
      if(t) t.textContent=title;
      if(b) b.textContent=body;
      if(typeof dialog.showModal==='function') dialog.showModal();
    }
    if(dialog && !dialog.dataset.bound){
      dialog.dataset.bound='1';
      const close=dialog.querySelector('[data-dialog-close]');
      const done=dialog.querySelector('[data-dialog-done]');
      if(close) close.addEventListener('click',()=>dialog.close());
      if(done) done.addEventListener('click',()=>dialog.close());
      dialog.addEventListener('click',e=>{
        if(e.target!==dialog) return;
        const r=dialog.getBoundingClientRect();
        if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom) dialog.close();
      });
    }

    document.querySelectorAll('[data-isw-reward]').forEach(btn=>{
      if(btn.dataset.bound) return; btn.dataset.bound='1';
      btn.addEventListener('click',()=>{
        showDialog('£'+btn.dataset.reward+' off your next order',
          btn.dataset.points+' points • Minimum eligible spend £'+btn.dataset.minimum+
          '. Valid for 90 days after exchange. One voucher per order; cannot be combined with other codes, referral vouchers or additional bundle discounts.');
      });
    });

    document.querySelectorAll('[data-isw-accessory]').forEach(btn=>{
      if(btn.dataset.bound) return; btn.dataset.bound='1';
      btn.addEventListener('click',()=>{
        const helmet=btn.dataset.iswAccessory==='helmet';
        showDialog(helmet?'Helmet with rechargeable light':'Scooter & bicycle cable lock',
          (helmet?'2,500':'1,000')+' available points + a qualifying paid order of £49 or more. The accessory item is paid for with points and ships with the paid order at no additional reward delivery charge. One gift per order; no other codes, vouchers or additional bundle discounts. Subject to stock; check fit and size.');
      });
    });

    document.querySelectorAll('[data-isw-refer]').forEach(btn=>{
      if(btn.dataset.bound) return; btn.dataset.bound='1';
      btn.addEventListener('click',()=>showDialog('Give £20. Get £20.',
        'Your friend must be a new customer and spend at least £299 on eligible products. Your £20 reward is issued after their return window closes, following verification, and requires a £299 minimum spend. Self-referrals do not qualify.'));
    });

    // Calculator
    document.querySelectorAll('[data-isw-calculator]').forEach(calc=>{
      if(calc.dataset.bound) return; calc.dataset.bound='1';
      const spend=calc.querySelector('[data-spend]');
      const slider=calc.querySelector('[data-spend-range]');
      const total=calc.querySelector('[data-total]');
      const base=calc.querySelector('[data-base]');
      const bonus=calc.querySelector('[data-bonus]');
      const worth=calc.querySelector('[data-worth]');
      const note=calc.querySelector('[data-calc-note]');
      const baseRate=Number(calc.dataset.baseRate||3);
      const multiplier=Number(calc.dataset.eventMultiplier||3);
      const bonusCap=Number(calc.dataset.eventCap||3000);
      let mode='standard';
      const fmt=n=>Math.floor(n).toLocaleString('en-GB');
      const money=n=>'£'+(Math.round(n*100)/100).toLocaleString('en-GB',{minimumFractionDigits:Number.isInteger(n)?0:2,maximumFractionDigits:2});
      function calculate(amount){
        const bp=Math.floor(amount*baseRate);
        let extra=0;
        if(mode==='triple') extra=Math.min(bonusCap, Math.max(0, Math.floor(amount*baseRate*(multiplier-1))));
        return {base:bp,bonus:extra,total:bp+extra};
      }
      function update(){
        let amount=Number(spend.value); if(!Number.isFinite(amount)) amount=0;
        amount=Math.min(Number(spend.max||10000),Math.max(0,amount));
        if(slider) slider.value=Math.min(Number(slider.max||1500),amount);
        const r=calculate(amount);
        if(total) total.textContent=fmt(r.total);
        if(base) base.textContent=fmt(r.base);
        if(bonus) bonus.textContent=fmt(r.bonus);
        if(worth) worth.textContent=money(r.total/100);
        if(note){
          note.textContent=mode==='triple'
            ? 'Illustration for eligible event spend, assuming no event bonus has already been earned. Extra points are capped at '+bonusCap.toLocaleString('en-GB')+' per account for the whole event.'
            : 'Standard purchase points only. Join, subscription and first-order bonuses are not included.';
        }
      }
      function setMode(next){
        mode=next;
        calc.querySelectorAll('[data-mode]').forEach(b=>{
          const active=b.dataset.mode===mode;
          b.classList.toggle('active',active); b.setAttribute('aria-pressed',String(active));
        });
        update();
      }
      if(spend){
        spend.addEventListener('input',update);
        spend.addEventListener('change',()=>{spend.value=Math.min(Number(spend.max||10000),Math.max(0,Number(spend.value)||0));update();});
      }
      if(slider) slider.addEventListener('input',()=>{spend.value=slider.value;update();});
      calc.querySelectorAll('[data-mode]').forEach(b=>b.addEventListener('click',()=>setMode(b.dataset.mode)));
      update();
      calc._iswSetMode=setMode;
    });

    document.querySelectorAll('[data-isw-try-triple]').forEach(btn=>{
      if(btn.dataset.bound) return; btn.dataset.bound='1';
      btn.addEventListener('click',()=>{
        const calc=document.querySelector('[data-isw-calculator]');
        if(calc && calc._iswSetMode) calc._iswSetMode('triple');
      });
    });

    // Mobile rails
    document.querySelectorAll('.rail-controls').forEach(control=>{
      if(control.dataset.bound) return; control.dataset.bound='1';
      const railClass=control.dataset.rail;
      const scope=control.closest('.isw-rewards-page');
      const rail=scope ? scope.querySelector('.'+railClass) : document.querySelector('.'+railClass);
      if(!rail) return;
      const cards=Array.from(rail.children);
      const position=control.querySelector('.rail-position');
      const buttons=Array.from(control.querySelectorAll('button[data-dir]'));
      function current(){
        const r=rail.getBoundingClientRect(); let best=0,d=Infinity;
        cards.forEach((card,i)=>{const nd=Math.abs(card.getBoundingClientRect().left-r.left); if(nd<d){d=nd;best=i;}});
        return best;
      }
      function sync(){
        const index=current();
        if(position) position.textContent=(index+1)+' / '+cards.length;
        if(buttons[0]) buttons[0].disabled=rail.scrollLeft<=2;
        if(buttons[1]) buttons[1].disabled=rail.scrollLeft>=rail.scrollWidth-rail.clientWidth-2;
      }
      function move(dir){
        const index=Math.max(0,Math.min(cards.length-1,current()+dir));
        const rr=rail.getBoundingClientRect(), tr=cards[index].getBoundingClientRect();
        rail.scrollTo({left:rail.scrollLeft+tr.left-rr.left,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      }
      buttons.forEach(b=>b.addEventListener('click',()=>move(Number(b.dataset.dir))));
      rail.addEventListener('scroll',sync,{passive:true});
      rail.addEventListener('keydown',e=>{if(e.target===rail&&['ArrowLeft','ArrowRight'].includes(e.key)){e.preventDefault();move(e.key==='ArrowLeft'?-1:1);}});
      window.addEventListener('resize',sync,{passive:true});
      sync();
    });

    // Sticky section nav
    if(nav && !nav.dataset.bound){
      nav.dataset.bound='1';
      const slot=nav.closest('.isw-nav-slot');
      const track=nav.querySelector('.isw-nav-track');
      const links=Array.from(nav.querySelectorAll('[data-section]'));
      const targets=links.map(link=>({link,section:document.getElementById(link.dataset.section)})).filter(x=>x.section);
      let raf=0,active='';
      function themeOffset(){
        const manual=Number(nav.dataset.fixedOffset||0);
        if(manual>0) return manual;
        const selector=nav.dataset.themeHeaderSelector||'#shopify-section-header, .shopify-section-group-header-group, #SiteHeader, .site-header, .header-wrapper, sticky-header, [data-sticky-header], .announcement-bar, #shopify-section-announcement, header[role="banner"]';
        let els=[]; try{els=Array.from(document.querySelectorAll(selector));}catch(e){}
        let bottom=0;
        els.forEach(el=>{
          if(el.contains(nav)) return;
          const st=getComputedStyle(el),r=el.getBoundingClientRect();
          if(!['fixed','sticky'].includes(st.position)||st.display==='none'||st.visibility==='hidden'||r.height<=0||r.bottom<=0||r.top>window.innerHeight*.45) return;
          const top=parseFloat(st.top);
          if(st.position==='sticky' && (!Number.isFinite(top)||r.top>top+2)) return;
          if(r.top<=bottom+2) bottom=Math.max(bottom,r.bottom);
        });
        return Math.min(bottom,window.innerHeight*.5);
      }
      function mark(id){
        if(id===active) return; active=id;
        links.forEach(link=>{
          if(link.dataset.section===id){
            link.setAttribute('aria-current','location');
            const left=link.offsetLeft-track.offsetLeft,right=left+link.offsetWidth;
            if(left<track.scrollLeft+12) track.scrollLeft=Math.max(0,left-20);
            else if(right>track.scrollLeft+track.clientWidth-12) track.scrollLeft=right-track.clientWidth+20;
          }else link.removeAttribute('aria-current');
        });
      }
      function layout(){
        raf=0;
        if(!slot||!track) return;
        const offset=themeOffset(), height=nav.getBoundingClientRect().height||58;
        const rect=slot.getBoundingClientRect();
        const last=targets[targets.length-1]?.section;
        const pageBottom=last ? last.getBoundingClientRect().bottom : document.body.getBoundingClientRect().bottom;
        const fixed=rect.top<=offset && pageBottom>offset+height;
        nav.classList.toggle('is-fixed',fixed);
        if(fixed){nav.style.top=offset+'px';nav.style.left=rect.left+'px';nav.style.width=rect.width+'px';}
        else{nav.style.top='';nav.style.left='';nav.style.width='';}
        track.classList.toggle('is-overflowing',track.scrollWidth>track.clientWidth+1);
        const line=offset+height+25; let cur=targets[0];
        targets.forEach(item=>{if(item.section.getBoundingClientRect().top<=line)cur=item;});
        if(cur) mark(cur.link.dataset.section);
      }
      function schedule(){if(!raf) raf=requestAnimationFrame(layout);}
      links.forEach(link=>link.addEventListener('click',e=>{
        const target=document.getElementById(link.dataset.section); if(!target) return;
        e.preventDefault();
        const top=target.getBoundingClientRect().top+window.scrollY-themeOffset()-nav.getBoundingClientRect().height-12;
        window.scrollTo({top:Math.max(0,top),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
        try{history.replaceState(null,'','#'+target.id);}catch(err){}
      }));
      window.addEventListener('scroll',schedule,{passive:true});
      window.addEventListener('resize',schedule,{passive:true});
      layout();
    }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
  else init();
  document.addEventListener('shopify:section:load',init);
})();
